import { render, staticRenderFns } from "./UploadHomework.vue?vue&type=template&id=0d7b2fe4"
import script from "./UploadHomework.vue?vue&type=script&lang=js"
export * from "./UploadHomework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports